import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

import LogoSprite from "assets/an_logo_sprites.png";

const butterflyAnimation = keyframes`
  from, 0% {
    background-position: 0 0;
  }
  100% {
    background-position: -90px 0;
  }
`;

/**
 * ANSpriteLogo is a styled component that displays the animated AnswersNow logo.
 * @component
 * @return {JSX.Element} ANSpriteLogo component
 */
const ANSpriteLogo = styled.figure`
  height: 41px;
  width: 30px;
  position: relative;
  margin: 0 auto 12px;
  background-image: url(${LogoSprite});
  background-size: 210px 41px;
  animation: ${butterflyAnimation} 0.9s steps(3) infinite;
`;

export default ANSpriteLogo;
